import React from 'react';

import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { Hamburger } from 'jbc-front/components/icons';
import { useTranslation } from 'react-i18next';

import styles from './SortableAllowancesTable.scss';

const AllowanceRow = SortableElement(({ allowance }) => (
  <tr className={styles.line}>
    <td className={styles.icon}>
      <Hamburger size={17} />
    </td>
    <td className={allowance.isInDisuse ? styles.through : ''}>{allowance.name}</td>
    <td className={allowance.isInDisuse ? styles.through : ''}>{allowance.displayFormulaDescription}</td>
  </tr>
));

const SortableAllowancesTable = SortableContainer(({ allowances }) => {
  const { t } = useTranslation();
  return (
    <div className="l-overflow-scroll">
      <table className="m-table-list">
        <colgroup>
          <col width={50} />
          <col width={200} />
          <col width={500} />
        </colgroup>
        <thead>
          <tr>
            <th />
            <th>{t('features.ClientBonusAllowances.components.BonusAllowancesTable.item_name')}</th>
            <th>{t('features.ClientBonusAllowances.components.BonusAllowancesTable.amount')}</th>
          </tr>
        </thead>
        <tbody>
          {(!allowances || allowances.length === 0) && (
            <tr>
              <td colSpan={3}>{t('features.EmployeeBonus.components.EmployeeBonusTable.no_data')}</td>
            </tr>
          )}
          {allowances &&
            allowances.map((allowance, index) => <AllowanceRow key={allowance.id} index={index} allowance={allowance} />)}
        </tbody>
      </table>
    </div>
  )
});
export default SortableAllowancesTable;
